module.exports = __webpack_public_path__ + "img/loading-update.9b32870c.svg";